module.exports = __webpack_public_path__ + "static/media/sidebar-9.f7c94f4d.jpeg";